import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  updateRltWorkOrderCache,
  useRltWorkOrderUpdateEndDateMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import t from "@/lang/lang";
import { DatetimePickerField } from "@/shared/components/field/date-picker-field";

export function WorkOrderEndDateInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [set] = useOptimisticDebouncedMutation(
    { id: workOrder.id, endDate: workOrder.endDate ?? null },
    updateRltWorkOrderCache,
    useRltWorkOrderUpdateEndDateMutation(),
  );

  return (
    <DatetimePickerField
      label={t("Ende der Arbeiten")}
      nullable
      date={workOrder.endDate}
      onDateChange={(endDate) => {
        // null clears the end date.
        set(
          { id: workOrder.id, endDate: endDate ?? null },
          { ...workOrder, endDate },
        );
      }}
      fieldName="endDate"
      disabled={disabled}
    />
  );
}
